<template>
  <div class="form-group" :class="icon">
    <label :for="id" :class="hidelabel ? 'sr-only' :'' ">{{ label }}</label>
    <select
      :id="id"
      class="form-control"
      v-bind="$attrs"
      @change="updateValue"
      :disabled="!options.length"
    >
      <option :value="defaultvalue" selected hidden>{{ label }}</option>
      <option
        v-for="option in options"
        :key="option._id"
        :value="option._id"
        :selected="option === value"
      >{{ option.name }}</option>
    </select>
    <span class="label label-danger form-error" v-if="errors[0]">
      <strong>
        <span class="prefix">{{ $t('errorPrefix') }}</span>
        <span v-html="errors[0].value"></span>
      </strong>
    </span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    options: {
      type: Array,
      required: true
    },
    value: [String, Number],
    label: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    icon: String,
    defaultvalue: String,
    errors: Array,
    hidelabel: Boolean
  },
  data() {
    return {};
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style lang="scss">
.-icon-after {
  position: relative;
  select {
    background-color: #cecece;
    -webkit-appearance: none;
    appearance: none;
    color: $brand-primary;
  }
  &::after {
    position: absolute;
    color: $brand-highlight;
    top: 18px;
    right: 15px;
    display: inline-block;
    width: 10px;
    height: 10px;
    font-family: "FontAwesome";
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    font-weight: 900;
    text-rendering: auto;
    line-height: 1;
  }
}
.-icon-marker {
  &::after {
    content: "\f0ec";
  }
}
</style>